import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Image, ImageModule } from '@teamfoster/sdk/image';
import { Header } from 'src/app/core/models/header.model';
import { DynamicHooksModule } from 'ngx-dynamic-hooks';
import { TextShapeComponent } from '../text-shape/text-shape.component';
import { BigTextComponent } from '../big-text/big-text.component';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';
import { HighlightPipe } from 'src/app/core/pipes/highlight.pipe';
import { CoreModule } from 'src/app/core/core.module';
import SplittingDirective from 'src/app/animations/directives/splitting.directive';
import { InViewModule } from '@teamfoster/sdk/in-view';
import { BehaviorSubject } from 'rxjs';
import { ScrollIndicatorComponent } from '../scroll-indicator/scroll-indicator.component';

@Component({
  selector: 'app-header-with-image',
  standalone: true,
  imports: [
    CommonModule,
    DynamicHooksModule,
    ImageModule,
    TextShapeComponent,
    BigTextComponent,
    ScrollIndicatorComponent,
    DictionaryNgrxModule,
    CoreModule,
    SplittingDirective,
    InViewModule,
  ],
  templateUrl: './header-with-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderWithImageComponent implements OnDestroy {
  @Input() randomTick: number = 0;
  @Input() header?: Header;
  @Input() image?: Image;
  @Input() title?: string;
  @Input() backgroundTitle?: string;

  @Input() inviewPort: boolean = false;

  @Output() visible = new EventEmitter<boolean>();

  constructor() {}

  ngOnDestroy(): void {
    this.visible.emit(false);
  }

  get headerImage() {
    if (this.image?.url) {
      return this.image;
    }
    if (this.header?.images?.length) {
      return this.header.images[this.randomTick % this.header.images.length];
    }
    if (this.header?.image?.url) {
      return this.header.image;
    }
    return undefined;
  }

  setNavTheme(e: boolean) {
    this.visible.emit(e);
  }
}
